import _actions_get_local from './_actions/get/local.js'
import _actions_get_course_to from './_actions/get/course_to.js'
import _actions_get_course_agency from './_actions/get/course_agency.js'
import _actions_get_course from './_actions/get/course.js'
import _actions_change_request_sum from './_actions/change/request_sum.js'
import _actions_change_debts from './_actions/change/debts.js'
import _actions_change_date from './_actions/change/date.js'
import _actions_change_course from './_actions/change/course.js'
import _actions_change_comment from './_actions/change/comment.js'
import _actions_change_CarryOverOfFunds from './_actions/change/CarryOverOfFunds.js'
import _actions_set_comment from './_actions/set_comment.js'
import _actions_reload from './_actions/reload.js'
import _actions_add from './_actions/add.js'
import _getters_sum_pay from './_getters/sum_pay.js'
import _getters_sum_all from './_getters/sum_all.js'
import _getters_sum from './_getters/sum.js'
import _getters_request_residue from './_getters/request_residue.js'
import _getters_request_debt from './_getters/request_debt.js'
import _getters_requests from './_getters/requests.js'
import _getters_loading from './_getters/loading.js'
import _getters_legals from './_getters/legals.js'
import _getters_item from './_getters/item.js'
import _getters_iso from './_getters/iso.js'
import _getters_contragents from './_getters/contragents.js'
import _getters_agreement from './_getters/agreement.js'
import _mutations_set_item from './_mutations/set_item.js'
import _mutations_set_data from './_mutations/set_data.js'
import _mutations_remove_item from './_mutations/remove_item.js'
import state from './_state/index.js'

export default {
    namespaced: true,
    state,
    mutations:{
        remove_item: _mutations_remove_item,
        set_data: _mutations_set_data,
        set_item: _mutations_set_item,
    },
    getters:{
        agreement: _getters_agreement,
        contragents: _getters_contragents,
        iso: _getters_iso,
        item: _getters_item,
        legals: _getters_legals,
        loading: _getters_loading,
        requests: _getters_requests,
        request_debt: _getters_request_debt,
        request_residue: _getters_request_residue,
        sum: _getters_sum,
        sum_all: _getters_sum_all,
        sum_pay: _getters_sum_pay,
    },
    actions:{
        add: _actions_add,
        reload: _actions_reload,
        set_comment: _actions_set_comment,
        change_CarryOverOfFunds: _actions_change_CarryOverOfFunds,
        change_comment: _actions_change_comment,
        change_course: _actions_change_course,
        change_date: _actions_change_date,
        change_debts: _actions_change_debts,
        change_request_sum: _actions_change_request_sum,
        get_course: _actions_get_course,
        get_course_agency: _actions_get_course_agency,
        get_course_to: _actions_get_course_to,
        get_local: _actions_get_local,
    },
}